import { Component, OnInit, Input, OnChanges, SimpleChanges, DoCheck } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { UserService } from 'src/app/services/shared/user.service';
import { ConfirmPasswordStateMatcher } from 'src/app/shared/validators/confirmPasswordStateMatcher';
import { PasswordValidator } from 'src/app/shared/validators/password.validators';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { AgentDetailsResponse } from '../model/agentDetailsResponse.model';

@Component({
  selector: 'terra-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit, OnChanges {

  @Input()
  model: AgentDetailsResponse;

  isLoading = false;
  isSaved = false;

  matcher = new ConfirmPasswordStateMatcher();

  formGroup = new UntypedFormGroup(
    {
      currentPassword: new UntypedFormControl('', [Validators.required]),
      password: new UntypedFormControl('', [Validators.required, Validators.minLength(8), PasswordValidator.PasswordStrength]),
      confirmPassword: new UntypedFormControl('', [Validators.required])
    },
    {
      validators: [PasswordValidator.MatchPassword, PasswordValidator.SamePassword]
    }
  );


  hasError = (control, error) => {
    return this.formGroup.get(control).hasError(error);
  }

  get isDisabled() {
    return this.model && this.model.ssoOnly;
  }

  constructor(
    private userService: UserService,
    private snackbarService: SnackbarService) { }


  savePassword = () => {
    this.isSaved = false;

    if (this.isLoading) {
      return;
    }

    if (this.formGroup.invalid) {
      for (const i in this.formGroup.controls) {
        if (this.formGroup.controls[i]) {
          this.formGroup.controls[i].markAsTouched();
        }
      }
      return;
    }
    this.isLoading = true;

    this.userService
      .changePassword(this.formGroup.get('currentPassword').value, this.formGroup.get('password').value, this.formGroup.get('confirmPassword').value)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        response => {
          this.formGroup.reset();
          this.isSaved = true;
          this.snackbarService.showGeneralMessage('Password updated');
        },
        error => {
          this.formGroup.reset();
          this.formGroup.get('currentPassword').setErrors({ badrequest: true });
        }
      );
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.model && changes.model.isFirstChange()) {
      if (this.model.ssoOnly) {
        this.formGroup.disable();
      }
    }
  }


}
